import { useCallback, useMemo, useState } from 'react';

export type PaneId = 'top' | 'bottom';

export interface SinglePaneLayout {
  expandedPane: PaneId | null;
  expand: (pane: PaneId) => void;
  restore: () => void;
  isExpanded: (pane: PaneId) => boolean;
}

export const getSinglePaneClass = (
  pane: PaneId,
  expandedPane: PaneId | null,
): string => {
  if (expandedPane === null) return 'h-full';
  if (expandedPane === pane) return 'h-full row-span-2';
  return 'hidden';
};

export default function useSinglePaneLayout(): SinglePaneLayout {
  const [expandedPane, setExpandedPane] = useState<PaneId | null>(null);

  const expand = useCallback((pane: PaneId) => setExpandedPane(pane), []);
  const restore = useCallback(() => setExpandedPane(null), []);

  return useMemo<SinglePaneLayout>(
    () => ({
      expandedPane,
      expand,
      restore,
      isExpanded: (pane: PaneId) => expandedPane === pane,
    }),
    [expandedPane, expand, restore],
  );
}
